import { TemperaturesChart } from "./TemperaturesChart";
export default TemperaturesChart;
